export default "__VITE_ASSET__DeTp7Vra__"